// extracted by mini-css-extract-plugin
export default {"container":"RichText_container__fR9AM"};